import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles()(() => ({
	table: {
		tableLayout: "fixed",
		width: "100%",
	},
	tableHead: {
		backgroundColor: "#D2D2D9",
		border: "0.5px solid",
	},
	tableHeadPrint: {
		backgroundColor: "#D2D2D9",
		border: "0.5px solid",
		display: "table-row-group",
	},
	userCell: {
		width: "12vw !important",
		minWidth: "12vw !important",
		maxWidth: "15vw !important",
		padding: "16px !important",
	},
	noDataTableRow: {
		borderBottom: "none !important",
	},
	tableBody: {
		border: "0.5px solid",
	},
}));

function getCellClass(header, classes) {
	if (header === "User") {
		return classes.userCell;
	}
	return "";
}

function CommonTable({ data = [], headers = [], columns = [], isPrint }) {
	const { classes } = useStyles();
	const { t } = useTranslation();

	// Normalise headers so callers may pass either a plain (already translated)
	// string or a { key, label } object. `key` is a stable, English,
	// logic-facing value used for column styling (see getCellClass); `label`
	// is the localized display value.
	const normalizedHeaders = headers.map((header) =>
		header && typeof header === "object"
			? { key: header.key ?? header.label, label: header.label }
			: { key: header, label: header }
	);

	return (
		<Table className={classes.table}>
			<TableHead
				className={isPrint ? classes.tableHeadPrint : classes.tableHead}
			>
				<TableRow>
					{normalizedHeaders.map((header, index) => (
						<TableCell
							key={header.key ?? index}
							className={getCellClass(header.key, classes)}
						>
							{header.label}
						</TableCell>
					))}
				</TableRow>
			</TableHead>
			<TableBody className={classes.tableBody}>
				{data?.length === 0 ? (
					<TableRow>
						<TableCell className={classes.noDataTableRow}>
							{t("message.noRecordsFound")}
						</TableCell>
					</TableRow>
				) : (
					data?.map((row) => (
						<TableRow key={row.createdDateTime + row.userName}>
							{columns.map((column, i) => (
								<TableCell
									key={column}
									className={getCellClass(
										normalizedHeaders[i]?.key,
										classes
									)}
								>
									{row[column]}
								</TableCell>
							))}
						</TableRow>
					))
				)}
			</TableBody>
		</Table>
	);
}

export default CommonTable;
